var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.facet.name
    ? _c(
        "div",
        {
          staticClass: "card border-0",
          attrs: { id: "facet-" + _vm.facet.id },
        },
        [
          _c(
            "button",
            {
              staticClass:
                "filter-title d-flex justify-content-between align-items-center text-left w-100 bg-white",
              class: { collapsed: !_vm.isFacetActive },
              attrs: { type: "button" },
              on: { click: _vm.toggleFacet },
            },
            [_vm._v("\n    " + _vm._s(_vm.facetName) + "\n  ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse",
              class: { show: _vm.isFacetActive },
              attrs: { id: "collapse-facet-" + _vm.facet.id },
              on: {
                click: function ($event) {
                  return $event.stopPropagation()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "pb-3 d-flex flex-column filter-facet-wrapper" },
                [
                  _vm.facet.type === "price"
                    ? _c("item-filter-price", {
                        attrs: { "category-id": _vm.categoryId },
                      })
                    : _vm._l(_vm.facet.values, function (value) {
                        return _c(
                          "div",
                          { key: value.id, staticClass: "form-check-wrapper" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-check mb-0 pl-0 cursor-pointer",
                              },
                              [
                                _c("input", {
                                  staticClass: "form-check-input d-none",
                                  attrs: {
                                    id: "option-" + value.id,
                                    type: "checkbox",
                                    disabled: _vm.isLoading || value.count <= 0,
                                    "aria-labelledby": "label-" + value.id,
                                  },
                                  domProps: {
                                    checked: _vm.isSelected(value.id),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.updateFacet(value)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "form-check-label d-flex align-items-center cursor-pointer w-100 position-relative",
                                    class: { "p-3": _vm.facet.id === 28 },
                                    attrs: {
                                      for: "option-" + value.id,
                                      id: "label-" + value.id,
                                    },
                                  },
                                  [
                                    _vm.facet.id === 28
                                      ? _c("img", {
                                          directives: [
                                            {
                                              name: "lazyload-img",
                                              rawName: "v-lazyload-img",
                                            },
                                          ],
                                          attrs: {
                                            "data-src": `${_vm.publicPath}/images/colors/${value.id}.webp`,
                                            alt: value.name,
                                            title: value.name,
                                            width: "48",
                                            height: "48",
                                            loading: "lazy",
                                          },
                                        })
                                      : _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getFormattedName(value.name)
                                            ),
                                          },
                                        }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            [201, 205, 212, 220, 224].includes(value.id)
                              ? _c("hr", { staticClass: "mt-3 mb-2" })
                              : _vm._e(),
                          ]
                        )
                      }),
                ],
                2
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }